import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    flex: 2;
    margin: 0 8px;
    text-align: center;
    flex-basis: 26%;
    margin-bottom: 16px;
    padding: 6px;
`;

export const StyledTitle = styled(Typography)`
    margin-bottom: 16px;
    color: #204158;
`;

export const StyledDescription = styled(Typography)`
    font-size: 1.3em;
    color: #2589be;
    font-weight: 500;
    text-align: left;
`;
